import { render, staticRenderFns } from "./shi-chan-hang-qing.vue?vue&type=template&id=54667fee&scoped=true"
import script from "./shi-chan-hang-qing.vue?vue&type=script&lang=js"
export * from "./shi-chan-hang-qing.vue?vue&type=script&lang=js"
import style0 from "./shi-chan-hang-qing.vue?vue&type=style&index=0&id=54667fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54667fee",
  null
  
)

export default component.exports